<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import { router } from "@inertiajs/vue2";
import { ref } from "vue";

const props = defineProps({
    campaigns: {
        type: Array,
        default: () => [],
    },
});

const headers = [
    {
        text: "Campaign",
        value: "name",
        sortable: false,
    },
    {
        text: "Description",
        value: "description",
        sortable: false,
    },
];

function handleSelect(item) {
    router.get(`/campaigns/${item.id}`);
}
</script>

<template>
    <AppLayout pageTitle="Campaigns">
        <v-data-table
            ref="table"
            :headers="headers"
            :items="campaigns"
            hide-default-footer
            disable-pagination
            mobile-breakpoint="0"
            class="cursor-pointer"
            @click:row="handleSelect($event)"
        >
        </v-data-table>
    </AppLayout>
</template>
